module.exports = __webpack_public_path__ + "img/rosemount-248-temperature-transmitter-1-family.f2a2f469.png";